let connect = require("react-redux").connect;
import React from "react";

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

class ModerationUnderReview extends React.Component {
    cancelSelectIcons(e) {
        e.preventDefault();

        this.props.unselectAllIcons();
    }

    constructor(props) {
        super(props);
    }

    denyIcons() {
        this.props.showModal(null, "DENY_ICONS", {
            upload: this.props.upload,
            icons: this.props.icons
        });
    }

    fireApproveAction() {
        if (this.props.upload.result !== actionTypes.APPROVE_ICONS) {
            this.props.approveIcons(
                this.props.icons.filter(function(icon) {
                    if (icon.selected === true) {
                        return icon;
                    }
                })
            );
        }
    }

    render() {
        let icons = this.props.icons,
            iconsSelected = this.props.iconsSelected,
            toggleAllIconSelectAction = this.toggleAllIconSelectAction();

        return (
            <span>
                <section className={`icon-moderation-menu row`}>
                    <div className="navbar_header col-lg-7">
                        <ul className="row">
                            <li className="col-lg-4">
                                <button className="ui_check-mark total-selected-btn black">
                                    {iconsSelected}
                                </button>
                                {toggleAllIconSelectAction}
                            </li>
                            <li className="col-lg-4">
                                <button
                                    className="approve-btn black"
                                    onClick={this.fireApproveAction.bind(this)}
                                >
                                    {"Approve Icon"}
                                </button>
                            </li>
                            <li className="col-lg-4">
                                <button
                                    className="deny-btn black"
                                    onClick={this.denyIcons.bind(this)}
                                >
                                    {"Deny Icon"}
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-1 col-sm-offset-4">
                        <a
                            href="#"
                            className="cancel-selection text-link"
                            onClick={this.cancelSelectIcons.bind(this)}
                        >
                            {"Cancel"}
                        </a>
                    </div>
                </section>
            </span>
        );
    }

    unSelectAllIcons(e) {
        e.preventDefault();

        this.props.unselectAllIcons();
    }

    selectAllIcons(e) {
        e.preventDefault();

        this.props.selectAllIcons();
    }

    toggleAllIconSelectAction() {
        let availableIcons = [];

        this.props.icons.forEach(icon => {
            if (!icon.status) {
                availableIcons.push(icon);
            }
        });

        if (availableIcons.length === this.props.iconsSelected) {
            return (
                <a
                    href="#"
                    className="select-all-icons text-link"
                    onClick={this.unSelectAllIcons.bind(this)}
                >
                    {"Unselect all visible"}
                </a>
            );
        } else {
            return (
                <a
                    href="#"
                    className="select-all-icons text-link"
                    onClick={this.selectAllIcons.bind(this)}
                >
                    {"Select all visible"}
                </a>
            );
        }
    }
}

module.exports = connect(null, {
    approveIcons: actions.approveIcons,
    unselectAllIcons: actions.unselectAllIcons,
    selectAllIcons: actions.selectAllIcons,
    showModal: actions.showModal
})(ModerationUnderReview);
